import { CurrencyPipe, DecimalPipe } from '@angular/common';
import {
  Component,
  ElementRef,
  OnDestroy,
  OnInit,
  ViewEncapsulation,
} from '@angular/core';
import { Store } from '@ngrx/store';
import { AngularCsv } from 'angular-csv-ext/dist/Angular-csv';

import { chain, orderBy, zipObject } from 'lodash';
import moment from 'moment-timezone';
import { Subscription } from 'rxjs';
import { distinctUntilChanged, filter, map } from 'rxjs/operators';
import { TRACKING_EVENTS } from 'src/app/app.constants';

import { AppState, USER_ROLES } from 'src/app';
import { TransactionType } from 'src/components/trade/transactions/enums/transactionType.enum';
import { BootstrapService, MixpanelService, TradeService } from 'src/core';

@Component({
  selector: 'hb-transactions-capitals',
  templateUrl: './transactionsCapitals.component.html',
  styleUrls: [
    './transactionsCapitals.component.scss',
    '../../transactions.component.scss',
  ],
  encapsulation: ViewEncapsulation.None,
  providers: [CurrencyPipe],
})
export class TransactionsCapitalsComponent implements OnInit, OnDestroy {
  bootstrapPromise: Promise<any>;
  today: any = moment().tz('America/Mexico_City').endOf('day').toDate();
  maxDateInitial: any = moment()
    .tz('America/Mexico_City')
    .subtract(1, 'd')
    .startOf('day')
    .toDate();

  maxDate: any = moment().tz('America/Mexico_City').toDate();

  minDate: any = moment().tz('America/Mexico_City').toDate();

  beginDate: any = moment()
    .tz('America/Mexico_City')
    .subtract(30, 'd')
    .startOf('day')
    .toDate();

  endDate: any = moment().tz('America/Mexico_City').endOf('day').toDate();

  label: any = {
    initial: '',
    final: '',
  };

  monthNames: any[] = [
    'Enero',
    'Febrero',
    'marzo',
    'Abril',
    'Mayo',
    'Junio',
    'Julio',
    'Agosto',
    'Septiembre',
    'Octubre',
    'Noviembre',
    'Diciembre',
  ];

  source: any[] = [];
  transactions: any[] = [];
  transactionsExcel: any[] = [];
  noRows = 0;
  currentRows = 0;
  totalRows = 0;
  totalPages = 0;
  page = 0;
  requestFailed = false;

  sorting: any = {
    prop: 'date',
    reverse: true,
  };

  selectPageSize: any = [
    { label: '12', value: 12 },
    { label: '25', value: 25 },
    { label: '50', value: 50 },
    { label: '100', value: 100 },
  ];
  selectedPageSize = this.selectPageSize[2];

  seeperiod = false;
  periodTime = '';
  initialDateIsSet = false;

  public constTop = 0;
  public constLeft = 0;

  private appComponent: any;
  private currentContract: string;
  private pageSize = 50;
  private currentPage = 1;
  private sortingProp = 23;
  private sortReverse = false;
  public isByOperation = true;

  private transactionsSubscription: Subscription;
  private currentContractSubscription: Subscription;
  public showSkeleton = true;
  public emptyState: any[] = [1, 2, 3];

  private userRoleSubscription: Subscription;
  private userGlobalSubscription: Subscription;

  private standardUser = false;
  private isUserGlobal = false;
  public showLoader = false;
  private transactionPromise: Promise<any>;

  constructor(
    private store: Store<AppState>,
    private bootstrapService: BootstrapService,
    private tradeService: TradeService,
    private elementRef: ElementRef,
    private mixpanelService: MixpanelService,
  ) {}

  scanForUserTypeContract() {
    this.userGlobalSubscription = this.store
      .select('userGlobal')
      .subscribe((value: any) => {
        this.isUserGlobal = value;
      });
  }

  scanForUserRole() {
    this.userRoleSubscription = this.store
      .select('userRole')
      .pipe(filter((value: any) => value !== undefined))
      .subscribe((value: any) => {
        this.standardUser =
          value === USER_ROLES.RI ||
          value === USER_ROLES.SUBDIRECTOR ||
          value === USER_ROLES.READONLY
            ? false
            : true;
      });
  }

  ngOnInit() {
    this.appComponent = document.getElementsByClassName('app-component')[0];
    this.bootstrapPromise = this.bootstrapService.initSession().then(() => {
      this.currentContractSubscription = this.store
        .select('currentContract')
        .pipe(
          map((values: any) => values.get('contractID')),
          filter((contractId: any) => contractId !== undefined),
          distinctUntilChanged(),
        )
        .subscribe((contractId: any) => {
          this.showSkeleton = true;
          this.currentContract = contractId;
          this.clearParamsToSearch();
          this.getData();
          this.toggleTradeBlotter(true);
        });
    });

    this.scanForUserRole();
    this.scanForUserTypeContract();

    this.periodTime =
      this.beginDate.getUTCDate().toString() +
      ' de ' +
      this.monthNames[this.beginDate.getMonth()] +
      ' de ' +
      this.beginDate.getFullYear() +
      ' - ' +
      this.endDate.getUTCDate().toString() +
      ' de ' +
      this.monthNames[this.endDate.getMonth()] +
      ' de ' +
      this.endDate.getFullYear();
    this.updateLabels(this.beginDate, this.endDate);
  }

  ngOnDestroy() {
    this.toggleTradeBlotter(false);
    this.appComponent.classList.remove('unscrollable');

    if (this.currentContractSubscription) {
      this.currentContractSubscription.unsubscribe();
    }

    if (this.transactionsSubscription) {
      this.transactionsSubscription.unsubscribe();
    }
  }

  showInterval(type: string): void {
    let warningTag: Element;
    let message = '';
    const intervalWarningElements: HTMLCollectionOf<Element> =
      document.getElementsByClassName('interval-warning');
    const hasIntervalWarning: boolean = intervalWarningElements.length > 0;
    if (!hasIntervalWarning) {
      warningTag = document.createElement('div');
      warningTag.setAttribute('class', 'interval-warning');
    } else {
      warningTag = intervalWarningElements[0];
    }

    if (type === 'initial') {
      message = 'Fecha inicial de consulta';
    } else if (type === 'end') {
      message = 'Selecciona un periodo de 1 a 60 días';
    }

    warningTag.innerHTML = message;
    const calendar = document.getElementsByClassName('mat-calendar')[0];
    calendar.classList.remove(
      type === 'initial' ? 'datepicker-end' : 'datepicker-start',
    );
    window.setTimeout(() => {
      calendar.classList.add(
        type === 'initial' ? 'datepicker-start' : 'datepicker-end',
      );
      const calendarContent = document.querySelector(
        'mat-calendar-header + .mat-calendar-content',
      ) as HTMLElement;
      calendarContent.style.marginTop = '15px';
      if (!hasIntervalWarning) {
        document
          .getElementsByClassName('mat-calendar-header')[0]
          .appendChild(warningTag);
      }
    }, 100);
  }

  getData(): void {
    this.noRows = 0;
    this.requestFailed = false;

    const info: any = {
      isSettlement: !this.isByOperation,
      pageIndex: this.currentPage - 1,
      pageSize: this.selectedPageSize.value,
      sortTransaction: this.sortingProp,
      startDate: this.beginDate,
      endDate: this.endDate,
      contractId: this.currentContract,
      ascendent: !this.sortReverse,
      rowNumber: undefined,
    };
    const BEGIN_DATE = moment(this.beginDate);
    const END_DATE = moment(this.endDate);
    const FILTER_PERIOD = END_DATE.diff(BEGIN_DATE, 'days');

    const FILTER_DATE = this.isByOperation ? 'Operation' : 'Settlement';
    this.mixpanelService.track(
      TRACKING_EVENTS.historical_filter_date.event,
      TRACKING_EVENTS.historical_filter_date.success(FILTER_DATE),
    );

    this.transactionsSubscription = this.tradeService
      .getTransactions(info)
      .subscribe(
        (data: any) => {
          this.mixpanelService.track(
            TRACKING_EVENTS.movements_filter_period.event,
            {
              ...TRACKING_EVENTS.movements_filter_period.success,
              Type: FILTER_PERIOD,
            },
          );
          if (data.transactions) {
            this.source = [];
            const dataFilter: any = data.transactions.filter((type: any) => {
              return (
                type.transactionTypeId !== TransactionType.CASH &&
                type.transactionTypeId !== TransactionType.DIVIDENDS
              );
            });
            this.noRows = dataFilter.length;
            this.totalRows = data.transactionsRowNumber;
            this.page++;
            this.totalPages = Math.ceil(
              this.totalRows / this.selectedPageSize.value,
            );
            if (this.noRows > 0) {
              for (const item of dataFilter) {
                const operationDate: any = moment(item.operationDate);
                const settlementDate: any = moment(item.settlementDate);

                item.operationDate = operationDate.format('DD/MMM/YYYY');
                item.operationDate = item.operationDate.replace('.', '');
                item.timeOp = operationDate.format('hh:mm:ss');
                item.groupOp = operationDate.format('MMMM YYYY').toUpperCase();

                item.settlementDate = settlementDate.format('DD/MMM/YYYY');
                item.settlementDate = item.settlementDate.replace('.', '');
                item.timeSt = settlementDate.format('hh:mm:ss');
                item.groupSt = settlementDate.format('MMMM YYYY').toUpperCase();
              }

              Array.prototype.push.apply(this.source, dataFilter);
              if (this.isByOperation) {
                this.transactions = chain(this.source)
                  .groupBy('groupOp')
                  .toPairs()
                  .map((item: any) => {
                    return zipObject(['groupOp', 'transactions'], item);
                  })
                  .value();
              } else {
                this.transactions = chain(this.source)
                  .groupBy('groupSt')
                  .toPairs()
                  .map((item: any) => {
                    return zipObject(['groupSt', 'transactions'], item);
                  })
                  .value();
              }
              this.showLoader = false;
              this.getTotalTransactions(this.transactions);
              this.fillPeriodTime(undefined);
              this.showSkeleton = false;
            } else {
              this.transactions = [];
              this.noRows = 0;
              this.showSkeleton = false;
            }
          } else {
            this.transactions = [];
            if (this.noRows <= 0) {
              this.totalRows = 0;
              this.currentRows = 0;
              this.page = 0;
              this.showSkeleton = false;
            }
          }
        },
        (error) => {
          this.mixpanelService.track(
            TRACKING_EVENTS.movements_filter_period.event,
            {
              ...TRACKING_EVENTS.movements_filter_period.error,
              Type: FILTER_PERIOD,
              Callback: error.message || error.ErrorMessage,
            },
          );
          this.requestFailed = true;
          this.transactions = [];
          this.noRows = 0;
          this.showSkeleton = false;
        },
      );
  }

  getMore(): void {
    this.showLoader = true;
    this.currentPage++;
    this.getData();
  }

  setType(isByOperation: boolean): void {
    this.isByOperation = isByOperation;
    this.clearParamsToSearch();
  }

  changeBeginDate(event: any): void {
    this.beginDate = event;

    const timeDiff = Math.abs(this.today.getTime() - this.beginDate.getTime());
    const diffDays = Math.ceil(timeDiff / (1000 * 3600 * 24)) - 1;

    if (diffDays < 60) {
      this.maxDate = moment(event)
        .add(diffDays, 'd')
        .tz('America/Mexico_City')
        .toDate();
      this.endDate = moment(event)
        .add(diffDays, 'd')
        .tz('America/Mexico_City')
        .toDate();
    } else {
      this.maxDate = moment(event)
        .add(60, 'd')
        .tz('America/Mexico_City')
        .toDate();
      this.endDate = moment(event)
        .add(60, 'd')
        .tz('America/Mexico_City')
        .toDate();
    }

    this.updateLabels(this.beginDate, this.endDate);
    this.validateDates();
    this.forceFinalDateChange();
  }

  changeEndDate(event: any): void {
    this.showSkeleton = true;
    this.endDate = moment(event)
      .tz('America/Mexico_City')
      .endOf('day')
      .toDate();
    this.validateDates();
    this.clearParamsToSearch();
    this.getData();
    this.initialDateIsSet = false;
    this.appComponent.classList.remove('unscrollable');
    this.updateLabels(this.beginDate, this.endDate);
  }

  applyToday(): void {
    setTimeout(() => {
      this.initialDateIsSet = false;
      const today = document.getElementsByClassName('mat-calendar-body-today');
      if (today.length > 0) {
        today[0].addEventListener('click', () => {
          this.showSkeleton = true;
          this.validateDates();
          this.clearParamsToSearch();
          this.getData();
          this.appComponent.classList.remove('unscrollable');
        });
      }
    }, 50);
  }

  forceFinalDateChange() {
    this.initialDateIsSet = true;
    this.appComponent.classList.add('unscrollable');

    setTimeout(() => {
      const datePickerBackdrop = document.getElementsByClassName(
        'cdk-overlay-backdrop-showing',
      )[0];
      if (datePickerBackdrop) {
        datePickerBackdrop.classList.add('unclickable');
      }
    }, 100);
  }

  onChangePageSize(event: any, item: any): void {
    window.scrollTo(0, 0);
    this.selectedPageSize = item;
    this.clearParamsToSearch();
    this.getData();
  }

  searchData(isOperation: boolean = true): void {
    this.showSkeleton = true;
    if (this.isByOperation === isOperation) {
      return;
    }
    this.isByOperation = isOperation;
    this.clearParamsToSearch();
    this.getData();
  }

  /**
   * Used to set property and reverse values
   */
  sortingBy(property: string): void {
    if (!property || property === '') {
      return;
    }

    if (this.sorting.prop === property) {
      this.sorting.reverse = !this.sorting.reverse;
    } else {
      this.sorting.prop = property;
      this.sorting.reverse = true;
    }

    this.sortData(this.sorting.prop, this.sorting.reverse);
  }

  /**
   * Used to clear params and restore dates.
   */
  restoreParams(): void {
    this.totalRows = 0;
    this.clearParamsToSearch();
    this.setType(false);
    this.beginDate = moment().tz('America/Mexico_City').startOf('day').toDate();
    this.endDate = moment().tz('America/Mexico_City').endOf('day').toDate();
  }

  /**
   * Used to generate CSV file for historical transactions
   */
  parseData(selector: string, headers?: object): void {
    let generatedFile;
    const date = new Date().getTime();

    const info: any = {
      isSettlement: !this.isByOperation,
      pageIndex: 0,
      pageSize: this.totalRows,
      sortTransaction: this.sortingProp,
      startDate: this.beginDate,
      endDate: this.endDate,
      contractId: this.currentContract,
      ascendent: !this.sortReverse,
      rowNumber: undefined,
    };

    this.transactionsSubscription = this.tradeService
      .getTransactions(info)
      .subscribe((data: any) => {
        if (data.transactions) {
          const dataFilter: any = data.transactions.filter((type: any) => {
            return (
              type.transactionTypeId !== TransactionType.CASH &&
              type.transactionTypeId !== TransactionType.DIVIDENDS
            );
          });

          for (const item of dataFilter) {
            const operationDate: any = moment(item.operationDate);
            const settlementDate: any = moment(item.settlementDate);

            item.operationDate = operationDate.format('DD/MMM/YYYY');
            item.operationDate = item.operationDate.replace('.', '');
            item.timeOp = operationDate.format('hh:mm:ss');
            item.groupOp = operationDate.format('MMMM YYYY').toUpperCase();

            item.settlementDate = settlementDate.format('DD/MMM/YYYY');
            item.settlementDate = item.settlementDate.replace('.', '');
            item.timeSt = settlementDate.format('hh:mm:ss');
            item.groupSt = settlementDate.format('MMMM YYYY').toUpperCase();
          }
          if (this.isByOperation) {
            this.transactionsExcel = chain(dataFilter)
              .groupBy('groupOp')
              .toPairs()
              .map((item: any) => {
                return zipObject(['groupOp', 'transactions'], item);
              })
              .value();
          } else {
            this.transactionsExcel = chain(dataFilter)
              .groupBy('groupSt')
              .toPairs()
              .map((item: any) => {
                return zipObject(['groupSt', 'transactions'], item);
              })
              .value();
          }

          const fileHeaders = {
            issueId: 'Emisora',
            date: 'Fecha',
            time: 'Hora',
            description: 'Descripción',
            shares: 'Títulos',
            price: 'Precio',
            yieldRate: 'Tasa',
            term: 'Plazo',
            interest: 'Intereses',
            taxes: 'Impuestos',
            commision: 'Comisión',
            amount: 'Importe',
            startingBalance: 'Saldo',
          };

          const exportObject = [];
          exportObject.push(fileHeaders);
          const length = this.transactionsExcel.length;
          for (let i = 0; i < length; i += 1) {
            exportObject.push({
              month: this.isByOperation
                ? this.transactionsExcel[i].groupOp
                : this.transactionsExcel[i].groupSt,
            });
            const transactionsLength =
              this.transactionsExcel[i].transactions.length;
            for (let j = 0; j < transactionsLength; j += 1) {
              const transaction = this.transactionsExcel[i].transactions[j];
              const transactionData: any = {
                issueId: transaction.issueId,
                date: this.isByOperation
                  ? transaction.operationDate
                  : transaction.settlementDate,
                time: this.isByOperation
                  ? transaction.timeOp
                  : transaction.timeSt,
                description: transaction.description,
                shares: new DecimalPipe('es-MX').transform(
                  transaction.shares,
                  '1.0-0',
                ),
                price: new CurrencyPipe('es-MX').transform(
                  transaction.price,
                  'MXN',
                  'symbol-narrow',
                  '1.2-2',
                ),
                yieldRate: new DecimalPipe('es-MX').transform(
                  transaction.yieldRate,
                  '1.2-2',
                ),
                term: new DecimalPipe('es-MX').transform(
                  transaction.term,
                  '1.0-0',
                ),
                interest: new CurrencyPipe('es-MX').transform(
                  transaction.interest,
                  'MXN',
                  'symbol-narrow',
                  '1.2-2',
                ),
                taxes: new CurrencyPipe('es-MX').transform(
                  transaction.taxes,
                  'MXN',
                  'symbol-narrow',
                  '1.2-2',
                ),
                commision: new CurrencyPipe('es-MX').transform(
                  transaction.commision,
                  'MXN',
                  'symbol-narrow',
                  '1.2-2',
                ),
                amount: new CurrencyPipe('es-MX').transform(
                  transaction.amount,
                  'MXN',
                  'symbol-narrow',
                  '1.2-2',
                ),
                startingBalance: new CurrencyPipe('es-MX').transform(
                  transaction.startingBalance,
                  'MXN',
                  'symbol-narrow',
                  '1.2-2',
                ),
              };
              exportObject.push(transactionData);
            }
          }
          generatedFile = new AngularCsv(
            exportObject,
            `GBM_Homebroker_Historial_de_Transacciones_${date}`,
          );
        }
      });
  }

  getTotalTransactions(transactions: any): void {
    const length = transactions.length;
    let rows = 0;
    for (let i = 0, j = length; i < j; i += 1) {
      rows += transactions[i].transactions.length;
    }
    this.currentRows = rows;
  }

  toggleTradeBlotter(isVisible: boolean) {
    const tradeBlotter = document.getElementsByClassName('trade-blotter');
    [].slice.call(tradeBlotter).forEach((value: any) => {
      (value as HTMLElement).style.display = isVisible ? 'none' : 'block';
    });
  }

  showCalendar(period: string) {
    this.periodTime = period;
    this.seeperiod = this.seeperiod === true ? false : true;
  }

  fillPeriodTime(data: any) {
    if (data === undefined) {
      this.periodTime =
        this.beginDate.getUTCDate().toString() +
        ' de ' +
        this.monthNames[this.beginDate.getMonth()] +
        ' de ' +
        this.beginDate.getFullYear() +
        ' - ' +
        this.endDate.getUTCDate().toString() +
        ' de ' +
        this.monthNames[this.endDate.getMonth()] +
        ' de ' +
        this.endDate.getFullYear();
    } else {
      this.periodTime = data.periodTime;
      this.beginDate = data.beginDate;
      this.endDate = data.endDate;
    }
  }

  public showTooltip(event: MouseEvent): void {
    const tooltipElement = (event.target as Element).lastElementChild;

    if (tooltipElement) {
      const { top, left } = (event.target as Element).getBoundingClientRect();
      this.constTop = top - 25;
      this.constLeft = left - 15;

      tooltipElement.classList.add('show');
    }
  }

  public hideTooltip(event: MouseEvent): void {
    const tooltipElement = (event.target as Element).lastElementChild;

    if (tooltipElement) {
      tooltipElement.classList.remove('show');
    }
  }

  private validateDates(): void {
    const diffMin: number = moment(this.endDate).diff(
      this.beginDate,
      'minutes',
    );
    if (diffMin <= 0) {
      this.endDate = moment().tz('America/Mexico_City').endOf('day').toDate();
    }

    // this.clearParamsToSearch();
  }

  private clearParamsToSearch(): void {
    this.requestFailed = true;
    this.noRows = undefined;
    this.totalRows = 0;
    this.currentRows = 0;
    this.currentPage = 1;
    this.transactions.length = 0;
    this.source.length = 0;
    this.page = 0;
    this.totalPages = 0;
  }

  /**
   * Used to sort transactions arrays.
   *
   * @param property - The property to sort
   * @param reverse - The sort type, i.e. revers = true -> desc, reverse = false -> asc
   */
  private sortData(property: string, reverse: boolean): void {
    const length = this.transactions.length;
    for (let i = 0, j = length; i < j; i += 1) {
      const transactionGroup = this.transactions[i];
      transactionGroup.transactions = orderBy(
        transactionGroup.transactions,
        [property],
        reverse ? ['desc'] : ['asc'],
      );
    }
  }

  private parseDate(date: Date): string {
    return `${date.getDate()} · ${date.getMonth() + 1} · ${date.getFullYear()}`;
  }

  private updateLabels(initialDate: Date, finalDate: Date): void {
    this.label = {
      initial: this.parseDate(initialDate),
      final: this.parseDate(finalDate),
    };
  }
}
